import { Action, ActionCreator, createAction, props } from '@ngrx/store';

import { UserModel } from '@app/models/server/user.model';

export enum Types {
  INIT = '[User] Init: Start',
  INIT_AUTHORIZED = '[User] Init: Authorized',
  INIT_UNAUTHORIZED = '[User] Init: Unauthorized',
  INIT_ERROR = '[User] Init: Error',
  SIGN_OUT = '[User] Sign Out: Start',
  SIGN_OUT_SUCCESS = '[User] Sign Out: Success',
  SIGN_OUT_ERROR = '[User] Sign Out: Error',
}

// Init
// check init state in future
export const INIT: ActionCreator<
  Types.INIT,
  (props: {}) => {} & Action<Types.INIT>
> = createAction(Types.INIT);

export const InitAuthorized: ActionCreator<
  Types.INIT_AUTHORIZED,
  (props: { _id: string; user: UserModel }) => {
    _id: string;
    user: UserModel;
  } & Action<Types.INIT_AUTHORIZED>
> = createAction(
  Types.INIT_AUTHORIZED,
  props<{ _id: string; user: UserModel }>(),
);

export const InitUnAuthorized: ActionCreator<
  Types.INIT_UNAUTHORIZED,
  (props: {}) => {} & Action<Types.INIT_UNAUTHORIZED>
> = createAction(Types.INIT_UNAUTHORIZED);

export const InitError: ActionCreator<
  Types.INIT_ERROR,
  (props: { error: string }) => { error: string } & Action<Types.INIT_ERROR>
> = createAction(Types.INIT_ERROR, props<{ error: string }>());

// Signout
export const SignOut: ActionCreator<
  Types.SIGN_OUT,
  (props: {}) => {} & Action<Types.SIGN_OUT>
> = createAction(Types.SIGN_OUT);

export const SignOutSuccess: ActionCreator<
  Types.SIGN_OUT_SUCCESS,
  (props: {}) => {} & Action<Types.SIGN_OUT_SUCCESS>
> = createAction(Types.SIGN_OUT_SUCCESS);

export const SignOutError: ActionCreator<
  Types.SIGN_OUT_ERROR,
  (props: {}) => {} & Action<Types.SIGN_OUT_ERROR>
> = createAction(Types.SIGN_OUT_ERROR);
